
import React from 'react'
import t from 'tcomb-form'
import isEmail from 'is-email'
import { passwordPattern, passwordErrorMessage } from 'lib/validation'
import css from './tcomb-types.module.css'

const passwordRegex = new RegExp(passwordPattern)

export const Password = t.refinement(t.String, (value) => passwordRegex.test(value))
Password.getValidationErrorMessage = (value) => {
  if (!value) {
    return 'Please enter a password.'
  }

  if (!passwordRegex.test(value)) {
    return passwordErrorMessage
  }
}

export const Email = t.refinement(t.String, (value) => isEmail(value))
Email.getValidationErrorMessage = (value) => {
  if (!value) {
    return 'Please enter an email address.'
  }

  if (!isEmail(value)) {
    return 'Please enter a valid email address.'
  }
}

export const booleanRadioTransformer = {
  format: (value) => {
    return String(value)
  },
  parse: (str) => {
    if (str === 'true') {
      return true
    }
    if (str === 'false') {
      return false
    }
    return str
  }
}

export const horizontalRadiosTemplate = t.form.Form.templates.radio.clone({
  renderRadios: (locals) => {
    return (
      <div className={css.horizontalRadios}>
        {t.form.Form.templates.radio.renderRadios(locals)}
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./lib/tcomb-types.js